import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import { Ng2TelInputModule } from 'ng2-tel-input';
import {MarketplacesService} from '../../core/services/marketplaces.service';
import {b2bclientsService} from '../b2bclients/services/b2bclients.service';
import { ShipmentPriceService } from '../shipment-price/services/shipment-price.service';
import {
    TableMarketplaceSalesOrderComponent
} from './marketplace-sales-order/components/table-sales-order/table-marketplace-sales-order.component';
import {SalesOrderManagementRoutingModule} from './sales-order-management-routing.module';
import {TableSalesOrderComponent} from './components/table-sales-order/table-sales-order.component';
import {OrdersSearchPageComponent} from './components/orders-search-page.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MaterialModule} from '../material.module';
import {MatTabsModule} from '@angular/material/tabs';
import {MatInputModule} from '@angular/material/input';
import {SaleOrderDetailsComponent} from './components/sale-order-details/sale-order-details.component';
import {MainDetailsComponent} from './components/sale-order-details/main-details/main-details.component';
import {GoodsListComponent} from './components/sale-order-details/goods-list/goods-list.component';
import {OrderInvoiceComponent} from './components/sale-order-details/order-invoice/order-invoice.component';
import {CoreModule} from 'src/app/core/core.module';
import {SaleOrderService} from './services/sale-order.service';
import {SaleOrderResolver} from './services/resolvers/sale-order-resolver.service';
import {RegistrationService} from '../customer-registration/services/registration.service';
import {MatDialogRef} from '@angular/material/dialog';
import {SaleProductService} from './services/sale-product.service';
import {ProductsService} from '../products/services/products.service';
import {SharedModule} from 'src/app/shared/shared.module';
import {MatTableExporterModule} from 'mat-table-exporter';
import {CheckpointsListComponent} from './components/sale-order-details/checpoints-list/checpoints-list.component';
import {ConfirmCreateComponent} from './components/sale-order-details/confirm-create/confirm-create.component';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {MatSelectInfiniteScrollModule} from 'ng-mat-select-infinite-scroll';
import {UpdateHistoryComponent} from './components/sale-order-details/update-history/update-history.component';
import {DetailsPopupComponent} from './components/sale-order-details/update-history/details-popup/details-popup.component';
import {
    CheckpointsListPopupComponent
} from './components/sale-order-details/checpoints-list/checkpoints-list-popup/checkpoints-list-popup.component';
import {
    SaleOrderDocumentsListComponent
} from './components/sale-order-details/sale-order-documents-list/sale-order-documents-list.component';
import {PortsService} from '../consolidate-shipments/services/ports.service';
import {GlobalSettingsService} from '../setting/services/global-settings.service';
import {OrderPickupInfoService} from '../consolidate-shipments/services/consolidate-shipments-pickup-info.service';
import {OrderProductService} from '../consolidate-shipments/services/consolidate-shipments-product.service';
import {TableB2BSalesOrderComponent} from './b2b-sales-order-management/components/table-sales-order/table-b2b-sales-order.component';
import {B2BSaleOrdersSearchPageComponent} from './b2b-sales-order-management/components/b2b-sale-orders-search-page.component';
import {InvatOrderSearchPageComponent} from './invat-order-search-page/invat-order-search-page.component';
import {ShopCategoriesService} from '../customer-management/services/shop-categories.service';
import {IndVatTableSalesOrderComponent} from './components/ind-vat-table-sales-order/ind-vat-table-sales-order.component';
import {InvatOrderUploadHistoryPageComponent} from './invat-order-upload-history-page/invat-order-upload-history-page.component';
import {
    TableSalesOrderUploadHistoryComponent
} from './components/invat-order-table-upload-history/ind-vat-table-sales-order-upload-history.component';

import {SaleOrderMarketplaceTemplatesComponent} from './components/so-marketplace-templates/so-marketplace-templates.component';
import {
    SaleOrderCreateTemplatePopupComponent
} from './components/so-marketplace-templates/so-create-template-popup/so-create-template-popup.component';
import {SaleOrderTemplateDetailsComponent} from './components/so-marketplace-templates/so-template-details/so-template-details.component';
import {SaleOrderFromXlsxComponent} from './components/so-from-xlsx/so-from-xlsx.component';
import {XlsxUploadPopupPopupComponent} from './invat-order-search-page/xlsx-upload-popup/xlsx-upload-popup.component';
import {
    MarketplaceSalesOrderPageComponent
} from './marketplace-sales-order/components/marketplace-sales-order-page.component';
import {CityService} from 'src/app/core/services/city.service';
import {
    TemplateNewFieldPopupComponent
} from './components/so-marketplace-templates/so-template-details/template-new-field-popup/template-new-field-popup.component';
import {SyncOptionsPopupComponent} from './components/so-from-xlsx/sync-options-popup/sync-options-popup.component';
import { OfflineShopAdminModule } from '../offline-shop-admin/offline-shop-admin.module';
import { BatchService } from '../batch/service/batch.service';
import { SaleOrderConsolsComponent } from './components/sale-order-details/sale-order-consols/sale-order-consols.component';
import { SOOutboundErrorsComponent } from './components/sale-order-details/so-outbound-errors/so-outbound-errors.component';
import { IncludeFilterPipe } from '../../shared/pipes/include-filter.pipe';
import { FilterPipe } from '../../shared/pipes/filter.pipe';
import { DeliveryStatusLabelPipe } from '../../shared/pipes/delivery-status-label.pipe';
import {
    SaleOrderParcelsComponent
} from "./components/sale-order-details/sale-order-parcels/sale-order-parcels.component";
import { SaleOrderRefundsComponent } from './components/sale-order-details/sale-order-refunds/sale-order-refunds.component';
import { SaleOrderPnlComponent } from './components/sale-order-details/sale-order-pnl/sale-order-pnl.component';
import { ExportProgressDialogComponent } from './components/export-progress-dialog/export-progress-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        SalesOrderManagementRoutingModule,
        MatFormFieldModule,
        MatSelectModule,
        MaterialModule,
        MatTabsModule,
        MatInputModule,
        CoreModule,
        SharedModule,
        MatTableExporterModule,
        NgxMatSelectSearchModule,
        MatSelectInfiniteScrollModule,
        OfflineShopAdminModule,
        Ng2TelInputModule,
    ],
    declarations: [
        OrdersSearchPageComponent,
        TableSalesOrderComponent,
        TableMarketplaceSalesOrderComponent,
        SaleOrderDetailsComponent,
        MainDetailsComponent,
        GoodsListComponent,
        OrderInvoiceComponent,
        CheckpointsListComponent,
        ConfirmCreateComponent,
        UpdateHistoryComponent,
        DetailsPopupComponent,
        CheckpointsListPopupComponent,
        SaleOrderDocumentsListComponent,
        TableB2BSalesOrderComponent,
        B2BSaleOrdersSearchPageComponent,
        MarketplaceSalesOrderPageComponent,
        InvatOrderSearchPageComponent,
        InvatOrderUploadHistoryPageComponent,
        IndVatTableSalesOrderComponent,
        TableSalesOrderUploadHistoryComponent,
        SaleOrderMarketplaceTemplatesComponent,
        SaleOrderCreateTemplatePopupComponent,
        SaleOrderTemplateDetailsComponent,
        SaleOrderFromXlsxComponent,
        XlsxUploadPopupPopupComponent,
        TemplateNewFieldPopupComponent,
        SyncOptionsPopupComponent,
        SaleOrderConsolsComponent,
        SaleOrderParcelsComponent,
        SOOutboundErrorsComponent,
        SaleOrderRefundsComponent,
        SaleOrderPnlComponent,
        ExportProgressDialogComponent,
    ],
    entryComponents: [
        ExportProgressDialogComponent,
    ],
    providers: [
        MarketplacesService,
        PortsService,
        CityService,
        ShipmentPriceService,
        SaleOrderService,
        RegistrationService,
        SaleProductService,
        DatePipe,
        SaleOrderResolver,
        ProductsService,
        GlobalSettingsService,
        OrderPickupInfoService,
        OrderProductService,
        ShopCategoriesService,
        BatchService,
        {
            provide: MatDialogRef,
            useValue: {}
        },
        b2bclientsService,
        DeliveryStatusLabelPipe,
    ],
    exports: [
        FilterPipe,
        IncludeFilterPipe,
    ]
})
export class SalesOrderManagementModule {
}
